export const ADD_PERMISSION_REQUEST = 'ADD_PERMISSION_REQUEST'
export const ADD_PERMISSION_SUCCESS = 'ADD_PERMISSION_SUCCESS'
export const ADD_PERMISSION_FAILED = 'ADD_PERMISSION_FAILED'